import { ApiClient } from "@/shared/services/api-client";
import { GetUsersIntegrationRequestModel, GetUsersIntegrationResponseModel } from "@/features/user/services/get-integration-model";
import { MoneyLinkException } from "@/shared/utils/custom-exception";

export class GetUsersIntegrationApi {
  /**
   * 統合ユーザ情報取得API
   */
  public getUsersIntegration = async (
    param: GetUsersIntegrationRequestModel
  ): Promise<GetUsersIntegrationResponseModel[]> => {
    const path = `/api/users/integration`;
    const res = await ApiClient.instance.post<GetUsersIntegrationResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
